import { Popover, PopoverTrigger, Box, PopoverContent, PopoverArrow, Text, PopoverFooter } from '@chakra-ui/react';
import { ExclamationIcon } from '@laliga-cdac/icons';
import Button from '@laliga-cdac/button';
import { useRef, createElement } from 'react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getTextColor = function getTextColor(color, darkMode, mode) {
  var _colorString$;

  if (mode === 'color') {
    return 'corporateBlack.500';
  }

  var colorString = color.split('.');
  var currentColorLiteral = (_colorString$ = colorString[0]) == null ? void 0 : _colorString$.toLowerCase().replace('corporate', '');
  var currentColorValue = colorString[1];
  return darkMode ? 'corporateWhite' : +currentColorValue >= getMaxDarkValue(currentColorLiteral) ? 'corporateWhite' : 'corporateBlack.500';
};

var getMaxDarkValue = function getMaxDarkValue(color) {
  switch (color) {
    case 'blue':
    case 'red':
    case 'purple':
      return 400;

    case 'green':
      return 500;

    case 'grey':
    case 'orange':
      return 600;

    default:
      return 700;
  }
};

var _excluded = ["children", "title", "subtitle", "okText", "cancelText", "onConfirm", "onCancel", "mode", "color", "icon", "placement", "fontSize", "darkMode"];

var Popconfirm = function Popconfirm(_ref) {
  var children = _ref.children,
      title = _ref.title,
      subtitle = _ref.subtitle,
      okText = _ref.okText,
      cancelText = _ref.cancelText,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      mode = _ref.mode,
      color = _ref.color,
      icon = _ref.icon,
      placement = _ref.placement,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? '1em' : _ref$fontSize,
      darkMode = _ref.darkMode,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var firstFieldRef = useRef(null);
  var backgroundColor = darkMode ? 'corporateBlack.500' : mode === 'background' ? color : '';
  var buttonColorsScheme = darkMode ? 'corporateWhite' : mode !== 'background' ? color.split('.')[0] || color : getTextColor(color, darkMode || color.toLowerCase().includes('black'), mode);
  return createElement(Popover, {
    initialFocusRef: firstFieldRef,
    placement: placement
  }, createElement(PopoverTrigger, null, createElement(Box, {
    w: "fit-content",
    h: "fit-content",
    bg: "inherit",
    p: "0"
  }, children)), createElement(PopoverContent, Object.assign({
    borderRadius: "0",
    p: "1.5em",
    border: "none",
    fontSize: fontSize,
    _focus: {
      outline: 'none'
    },
    boxShadow: "0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%)"
  }, rest, {
    bg: backgroundColor
  }), createElement(PopoverArrow, {
    bg: backgroundColor
  }), createElement(Box, {
    d: "flex",
    justifyContent: "space-between"
  }, createElement(Box, {
    w: "10%",
    mr: "5px"
  }, icon || createElement(ExclamationIcon, {
    boxSize: "1.5em",
    color: mode !== 'color' ? getTextColor(color, darkMode || color.toLowerCase().includes('black'), mode) : color,
    "data-testid": 'exclamation-icon-test-id'
  })), createElement(Box, {
    w: "90%",
    color: getTextColor(color, darkMode || color.toLowerCase().includes('black'), mode)
  }, createElement(Text, {
    fontWeight: "bold"
  }, " ", title), createElement(Text, null, subtitle))), createElement(PopoverFooter, {
    border: "0",
    d: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    pb: 4,
    mt: "auto"
  }, createElement(Box, {
    d: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    w: "full",
    color: buttonColorsScheme
  }, createElement(Button, {
    colorScheme: buttonColorsScheme,
    variant: "outline",
    borderRadius: "100",
    onClick: function onClick() {
      return onCancel();
    },
    border: "none",
    size: "sm"
  }, cancelText), createElement(Button, {
    colorScheme: buttonColorsScheme,
    variant: "outline",
    borderRadius: "100",
    borderWidth: "2px",
    onClick: function onClick() {
      return onConfirm();
    },
    ml: "8px",
    size: "sm"
  }, okText)))));
};

export default Popconfirm;